var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1E81F7",
    width: "40px",
    height: "40px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.935,8.094A7,7,0,0,0,3,9V21a1,1,0,0,0,2,0V9a4.993,4.993,0,0,1,9.913-.858A5.177,5.177,0,0,0,11,13.215V14.5a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V13A5,5,0,0,0,16.935,8.094Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V19A1,1,0,0,0,16,18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V19A1,1,0,0,0,20,18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,18a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V19A1,1,0,0,0,12,18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.9b011d44f621e8b684612e6fe0e287dc.svg";
export { ForwardRef as ReactComponent };